import * as Yup from 'yup'
import dayjs from 'dayjs';
export const phoneNumberRegex = /^[0-9]{10}$/;
export const zipCodeRegex = /^[A-Za-z0-9]{5,6}$/;
const today = new Date()
export const EMAIL = {
  label: "Email",
  validation: {
    required: "Email is required",
    valid: "Please enter a valid email address.",
    invalidCaps: 'Email is invalid, please type in lowercase.',
  },
};
export const ZIP_CODE = {
  label: "Zip Code",
  validation: {
    valid: "Zip Code must be a valid alphanumeric string with 5 or 6 characters",
    minLength: {
      value: 5,
      message: "Zip Code must be at least 5 digits",
    },
    maxLength: {
      value: 6,
      message: "Zip Code must not exceed 6 digits",
    },
  },
  regex: zipCodeRegex
};
export const HOSPITAL_NAME = {
  label: "Hospital Name",
  validation: {
    valid: "Hospital name is required.",
    required:"Hospital name is required"
  },
};

export const PHONE_NUMBER = {
  label: "Phone Number",
  validation: {
    valid: "Please enter a valid 10-digit contact number.",
    required:"Phone Number is required"
  },
};

export const WHATSAPP_NUMBER = {
  label: "Whatsapp Number",
  validation: {
    valid: "Please enter a valid 10-digit whatsapp number.",
    required:"Whatsapp Number is required"
  },
};

export const FIRST_Name = {
  label: "First Name",
  validation: {
    valid: "First Name is required",
    required:"First Name is required"
  },
};

export const LAST_Name = {
  label: "Last Name",
  validation: {
    valid: "Last Name is required",
    required:"Last Name is required"
  },
};

export const DOB = {
  label: "Date of Birth",
  validation: {
    valid: "Date of Birth is required",
    required:"Date of Birth is required"
  },
};
export const LICENSE_NUMBER = {
  label: "LICENSE NUMBER",
  validation: {
    valid: "License number is required",
    required:"License number is required"
  },
};

export const ABHA_NUMBER = {
  label: "ABHA NUMBER",
  validation: {
    valid: "ABHA number is required",
    required:"ABHA number is required"
  },
};

export const ID_CARD_NUMBER = {
  label: "ID Card NUMBER",
  validation: {
    valid: "ID Card number is required",
    required:"ID Card number is required"
  },
};

export const ID_CARD_TYPE = {
  label: "ID Card",
  validation: {
    valid: "ID Card Type is required",
    required:"ID Card Type is required"
  },
};

export const ID_CARD_ATTACHEMENT = {
  label: "ID Attachement",
  validation: {
    valid: "ID Card Attachement is required",
    required:"ID Card Attachement is required"
  },
};

export const HOME_ADDRESS = {
  label: "Home Address",
  validation: {
    valid: "Home Address is required",
    required:"Home Address is required"
  },
}

export const STUDY_REGION = {
  label: "Study Region",
  validation: {
    valid: "Study Region is required",
    required:"Study Region is required"
  },
}

export const MODALITY_TYPE = {
  label: "Modality Type",
  validation: {
    valid: "Modality Type is required",
    required:"Modality Type is required"
  },
}

export const APPOINTMENT_DATE = {
  label: "Appointment Date",
  validation: {
    valid: "Appointment Date is required",
    required:"Appointment Date is required"
  },
};

export const APPOINTMENT_TIME = {
  label: "Appointment Time",
  validation: {
    valid: "Appointment Time is required",
    required:"Appointment Time is required"
  },
}

export const APPOINTMENT_DOCTOR_NAME = {
  label: "Doctor Name",
  validation: {
    valid: "Doctor Name is required",
    required:"Doctor Name is required"
  },
}

export const APPOINTMENT_MODALITY_TYPE = {
  label: "Modality Type",
  validation: {
    valid: "Modality Type is required",
    required:"Modality Type is required"
  },
}

export const GENDER = {
  label: "Gender",
  validation: {
    valid: "Gender is required",
    required: "Gender is required"
  },
}

export const MARITAL_STATUS = {
  label: "Marital Status",
  validation: {
    valid: "Marital Status is required",
    required: "Marital Status is required"
  },
}

export const PHYSICIAN_NAME = {
  label: "Physician Name",
  validation: {
    valid: "Physician Name is required",
    required: "Physician Name is required"
  },
}

export const PatientDemographicFormSchema=Yup.object().shape({
  gender:Yup.string().required(GENDER.validation.required),
  maritalStatus : Yup.string().required(MARITAL_STATUS.validation.required),
  firstName :Yup.string().required(FIRST_Name.validation.required),
  lastName:Yup.string().required(LAST_Name.validation.required),
  zipCode: Yup.string()
  .min(ZIP_CODE.validation.minLength.value, ZIP_CODE.validation.minLength.message)
  .max(ZIP_CODE.validation.maxLength.value, ZIP_CODE.validation.maxLength.message)
  .matches(ZIP_CODE.regex, ZIP_CODE.validation.valid),
  emailId: Yup.string()
  .matches(
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|net|org|edu|gov|in)$/,
    'Please enter a valid email address with a common domain'
  )
  .email('Email must be a valid email address')
  .optional().test('no-uppercase', EMAIL.validation.invalidCaps, value => {
    return !value || value === value.toLowerCase();
  }),
  dob: Yup.date().required(DOB.validation.required).nullable()
        .test('isValid', 'Date of birth is required', (value) => value && dayjs(value).isValid()),
  age: Yup.string()
    .required('Age is required')
    .matches(/^[0-9]{1,3}$/, 'Age must be a number')
    .test('valid-age', 'Age must be between 0 and 150', value => {
      const n = Number(value);
      return n >= 0 && n <= 150;
    }),
  homeAddress:Yup.string().required(HOME_ADDRESS.validation.required),
  phoneNumber:Yup.string().matches(phoneNumberRegex).max(10, "Contact number cannot be more than 10 digits").required(PHONE_NUMBER.validation.valid),
  whatsappNumber:Yup.string().matches(phoneNumberRegex).max(10, "WhatsApp number cannot be more than 10 digits").required(WHATSAPP_NUMBER.validation.valid),
  orgID: Yup.string().when('idType', {
    is: 'government',
    then: (schema) => schema
      .required('Government ID is required')
      .matches(/^[0-9]+$/, 'Government ID must contain only numbers'),
    otherwise: (schema) => schema.notRequired()
  }),
  height: Yup.number()
  .min(10, 'Height must be greater than or equal to 10')
  .nullable()
  .transform((value, originalValue) => (originalValue === '' ? null : value)),
  weight: Yup.number()
  .min(10, 'Weight must be greater than or equal to 10')
  .nullable()
  .transform((value, originalValue) => (originalValue === '' ? null : value))
})


export const InsuranceAndIDFormSchema = Yup.object().shape({
  idCardType: Yup.string(),

  idCardNumber: Yup.string()
    .when('idCardType', (idCardType, schema) => {
      switch (idCardType[0]) {
        case 'AADHAR':
          return schema
            .matches(/^\d{12}$/, 'Aadhar number must be 12 digits');
        case 'PAN':
          return schema
            .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'PAN must be in the format ABCDE1234F');
        case 'PASSPORT':
          return schema
            .matches(/^[A-PR-WYa-pr-wy][1-9]\d\s?\d{4}[1-9]$/, 'Passport number must be in the format A1234567');
        case 'DL':
          return schema
            .matches(/^[A-Z]{2}[0-9]{2}[0-9]{11}$/, 'Invalid Driving License number');
        case 'VOTERID':
          return schema
            .matches(/^[A-Z]{3}[0-9]{7}$/, 'Voter ID number must be in the format ABC1234567');
      }
    }),

  idCardAttachement: Yup.string(),

  AbhaNumber: Yup.string()
    .matches(/^[0-9]{14}$/, 'ABHA number must be a 14-digit numeric string')
    // .required(ABHA_NUMBER.validation.required),
});

export const EmergencyInfoAndReferringFormSchema = Yup.object().shape({
  physicianWhatsappNumber: Yup.string()
    .matches(phoneNumberRegex, WHATSAPP_NUMBER.validation.valid)
    .max(10, "Contact number cannot be more than 10 digits")
    .nullable(),

  physicianContactNumber: Yup.string()
    .matches(phoneNumberRegex, PHONE_NUMBER.validation.valid)
    .max(10, "WhatsApp number cannot be more than 10 digits")
    .nullable(),
    physicianName:Yup.string(),
   // physicianName:Yup.string().required(PHYSICIAN_NAME.validation.required),
});



export const PayementAndBillingFormSchema = Yup.object().shape({
  appointmentDate:Yup.string().required(APPOINTMENT_DATE.validation.required),
  appointmentTime:Yup.string().required(APPOINTMENT_TIME.validation.required),
  appointmentModalityType:Yup.string().required(APPOINTMENT_MODALITY_TYPE.validation.required),
  appointmentDoctorName:Yup.string().required(APPOINTMENT_DOCTOR_NAME.validation.required)
})
